export const onlyNumbers = (value: string): string => {
    return value.replace(/\D/g, "");
}

export const formatCpfCnpj = (value: string): string => {
    let valueNumbers = onlyNumbers(value);
    if (valueNumbers.length === 11){
        return valueNumbers.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    }
    return valueNumbers.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
}

export const formatBoolean = (value: string | boolean): string => {
    return value === 'sim' || value === true ? 'Sim' : 'Não';
}

export const formatCurrency = (value: number): string => {
    return Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
}

export const formatPercent = (value: number): string => {
    return Intl.NumberFormat('pt-BR', { style: 'percent', currency: 'BRL' }).format(value/100);
}